import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { BalanceThreshold } from '@components/Billing/Balance/BalanceThreshold';
import { BalanceTopUp } from '@components/Billing/Balance/BalanceTopUp';
import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { Page404, Page500 } from '@containers/ErrorPages';
import { billingApi } from '@reducers/billing';

export const Balance = () => {
  const navigate = useNavigate();
  const { login } = useSelector((state) => state.auth.user);
  const { isPrepaid } = useSelector((state) => state.auth.user);
  const { data, isLoading, isFetching, isError } =
    billingApi.useGetBalanceQuery({ login });

  if (!isPrepaid) {
    return <Page404 />;
  }
  if (isLoading || isFetching) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    return <Page500 />;
  }
  return (
    <>
      <Row className="mb-3">
        <Col className="mt-2">
          <h3 className="border-bottom">Current balance: {data.balance}</h3>
        </Col>
        <Col className="mt-2">
          <Button
            size="sm"
            variant="didxl"
            onClick={() => navigate('/billing/balance/history')}
          >
            Show history balance
          </Button>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <BalanceTopUp />
        </Col>
        <Col md={6}>
          <BalanceThreshold
            currentThreshold={data.balance_threshold}
            currentThresholdValue={data.balanceThresholdValue}
          />
        </Col>
      </Row>
    </>
  );
};
